import {apiRequest} from "../action/api.action"
import { FETCH_SERVICE_PORT_CONTACTS, FETCH_SERVICE_PORT_CONTACTS_FAILURE, FETCH_SERVICE_PORT_CONTACTS_SUCCESS } from "../action/services.action";

export const servicesFlow = ({dispatch}) => next => action => {

  next(action)
  
  if(action.type === FETCH_SERVICE_PORT_CONTACTS) {
    let url = `/api/v3/service-supplier/${action.payload.companyId}/service-port-contacts`;
    dispatch(apiRequest('GET', url, null, FETCH_SERVICE_PORT_CONTACTS_SUCCESS, FETCH_SERVICE_PORT_CONTACTS_FAILURE));
  } 
};

export const servicesMdl = [servicesFlow];